import type { FormattersInitializer } from "typesafe-i18n";
import { uppercase } from "typesafe-i18n/formatters";
import type { Formatters, Locales } from "./i18n-types";

export const initFormatters: FormattersInitializer<Locales, Formatters> = (locale: Locales) => {
	const formatters: Formatters = {
		// add your formatter functions here
		underline: (value: string) => `<underline>${value}</underline>`,
		bold: (value: string) => `<bold>${value}</bold>`,
		uppercase: uppercase,
		badgeGreen: (value: string) => `<badgeGreen>${value}</badgeGreen>`,
	};

	return formatters;
};
